import { css } from "styled-components";
import { theme } from "lib/contexts/themeContext";

const styles = css`
  font-size: 16px;
  line-height: 24px;

  // links within content
  section {
    p > a,
    li > a,
    table a {
      &:hover {
        text-decoration: underline;
      }
    }
  }

  // fixed header anchor navigation hack
  h2::before {
    content: "";
    display: block;
    height: 100px; /* fixed header height*/
    margin: -100px 0 0; /* negative fixed header height */
  }

  h1 {
    font-weight: bold;
    font-size: 30px;
    line-height: 42px;
  }

  h1 + p {
    font-size: 16px;
  }

  h2 {
    position: relative;
    font-weight: bold;
    font-size: 24px;
    line-height: 34px;
    margin-bottom: 40px;

    &:hover {
      // anchor link icon
      .icon-link {
        &::after {
          content: "🔗";
          position: relative;
          left: 10px;
        }
      }
    }
  }

  h3 {
    margin: 40px 0 40px;
    font-size: 20px;
    line-height: 28px;
  }

  h4 {
    font-size: 18px;
  }

  // reserved for article subtitles
  h6 {
    margin: 20px 0 60px;
    font-size: 20px;
    line-height: 28px;
    font-weight: 500;
  }

  blockquote {
    line-height: 24px;
    font-size: 16px;
    font-style: italic;
    font-weight: 400;
    margin: 100px 0 0;
  }

  hr {
    margin: 100px 0 80px;
  }

  // tables
  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    thead {
      tr {
        th {
          text-align: left;
          vertical-align: top;
          padding: 20px 0;
          border-top: 1px solid #555555;
          border-bottom: 1px solid #555555;
          width: 100%;
        }
      }
    }
    td {
      padding: 20px 20px 20px 0;
      border-bottom: 1px solid #eeeeee;
    }
  }

  ol,
  ul {
    padding-left: 20px;
  }

  li {
    margin-bottom: 10px;
  }

  p > img {
    display: block;
    margin: 78px auto;
    max-width: 100%;
    max-height: 600px;
  }

  .footnotes {
    font-size: 12px;
    line-height: 20px;
    color: #777777;
  }

  // table of contents (toc)
  .toc-container {
    nav.toc {
      position: sticky;
      visibility: visible;
    }
  }

  nav.toc {
    position: absolute;
    visibility: none;
    width: 100%;
    max-width: 260px;
    top: 70px;
    right: 50px;
    ul,
    ol {
      list-style-type: none;
    }
    li {
      font-weight: bold;
      font-size: 14px;
      line-height: 22px;
      padding: 15px 20px;
      border-radius: 10px;
      color: black;
      transition: background-color 0.4s ease-in-out;

      &:hover,
      &.active {
        background-color: ${theme.palette.grey[50]};
      }
    }
    li a {
      color: inherit;
    }
  }
`;

export default styles;
